import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { Form, Field, Input } from '../../../../components/Form';
import firebase from "firebase/compat/app";
import { FirebaseAuth } from '../../../../components/FirebaseAuth/firebase';
import Alert from '../../../../components/Alert';
import UserPageLayout from '../../../../components/user/UserPageLayout';
import { log, UPDATE_PASSWORD } from "../../../../libs/log";
import TotpCodeForm from '../../../../components/user/TotpCodeForm';
import { isMfaRequired } from '../../../../libs/mfa';
import { authErrorMessage } from '../../../../libs/authErrors';
var UpdatePassword = function () {
    var title = "Change Your Password";
    var _a = useState({
        hasError: false,
        error: null,
        value: ""
    }), password = _a[0], setPassword = _a[1];
    var _b = useState({
        hasError: false,
        error: null,
        value: ""
    }), newPassword = _b[0], setNewPassword = _b[1];
    var _c = useState({
        hasError: false,
        error: null,
        value: ""
    }), confirmPassword = _c[0], setConfirmPassword = _c[1];
    var _d = useState({
        status: null,
        message: ''
    }), result = _d[0], setResult = _d[1];
    var _e = useState(false), inSubmit = _e[0], setInSubmit = _e[1];
    // Set when reauthentication comes back needing the account's second factor.
    var _f = useState(null), mfaResolver = _f[0], setMfaResolver = _f[1];
    /** The actual change, reused whether or not a second factor was challenged. */
    var applyNewPassword = function () {
        var user = FirebaseAuth.auth().currentUser;
        if (user === null) {
            setResult({ status: false, message: 'You are not logged in.' });
            setInSubmit(false);
            return;
        }
        user.updatePassword(newPassword.value)
            .then(function () {
            log(UPDATE_PASSWORD);
            setResult({ status: true, message: 'Your password has been updated.' });
            setInSubmit(false);
        }).catch(function (err) {
            setResult({ status: false, message: authErrorMessage(err === null || err === void 0 ? void 0 : err.code) || 'We could not change your password.' });
            setInSubmit(false);
        });
    };
    return (_jsxs(UserPageLayout, { title: title, children: [result.status === null && mfaResolver !== null &&
                _jsx(TotpCodeForm, { resolver: mfaResolver, onSuccess: function () { setMfaResolver(null); setInSubmit(true); applyNewPassword(); }, onFailure: function (msg) { setMfaResolver(null); setResult({ status: false, message: msg }); } }), result.status === null && mfaResolver === null &&
                _jsxs(Form, { handleSubmit: function (e) {
                        e.preventDefault();
                        setInSubmit(true);
                        if (newPassword.value !== confirmPassword.value) {
                            setConfirmPassword({
                                hasError: true,
                                error: 'The confirm password does not match with the new password.',
                                value: password.value
                            });
                            setInSubmit(false);
                        }
                        else {
                            var user = FirebaseAuth.auth().currentUser;
                            if (user === null) {
                                setResult({
                                    status: false,
                                    message: 'You are not logged in.'
                                });
                                setInSubmit(false);
                                return;
                            }
                            // check password
                            var credential = firebase.auth.EmailAuthProvider.credential(user.email || "", //login will fail if email is missing
                            password.value);
                            user.reauthenticateWithCredential(credential)
                                .then(function () {
                                applyNewPassword();
                            }).catch(function (err) {
                                // This catch used to be blind and always blamed the
                                // password. Once a second factor is enrolled,
                                // reauthenticateWithCredential also throws
                                // auth/multi-factor-auth-required — so a user typing the
                                // CORRECT password was told it was wrong.
                                if (isMfaRequired(err)) {
                                    setMfaResolver(err.resolver);
                                    setInSubmit(false);
                                    return;
                                }
                                if ((err === null || err === void 0 ? void 0 : err.code) === 'auth/wrong-password' || (err === null || err === void 0 ? void 0 : err.code) === 'auth/invalid-credential') {
                                    setPassword({
                                        hasError: true,
                                        error: 'Incorrect password, authentication failed.',
                                        value: password.value
                                    });
                                    setInSubmit(false);
                                    return;
                                }
                                setResult({ status: false, message: authErrorMessage(err === null || err === void 0 ? void 0 : err.code) || 'We could not change your password.' });
                                setInSubmit(false);
                            });
                        }
                    }, disabled: password.hasError || newPassword.hasError || confirmPassword.hasError || password.value === "" || newPassword.value === "" || confirmPassword.value === "" || inSubmit, inSubmit: inSubmit, enableDefaultButtons: true, backToUrl: "/user/profile", children: [_jsx(Field, { label: "Current Password", children: _jsx(Input, { type: "password", name: "password", hasError: password.hasError, error: password.error, required: true, changeHandler: setPassword }) }), _jsx(Field, { label: "New Password", children: _jsx(Input, { type: "password", name: "newPassword", hasError: newPassword.hasError, error: newPassword.error, required: true, minLen: 6, maxLen: 20, changeHandler: setNewPassword }) }), _jsx(Field, { label: "Confirm Password", children: _jsx(Input, { type: "password", name: "confirmPassword", hasError: confirmPassword.hasError, error: confirmPassword.error, required: true, minLen: 6, maxLen: 20, changeHandler: setConfirmPassword }) })] }), result.status === false &&
                _jsxs(_Fragment, { children: [_jsx(Alert, { type: "danger", dismissible: false, message: result.message, onDismiss: function () { } }), _jsx("button", { className: "btn btn-primary mr-2", onClick: function () {
                                setResult({
                                    status: null,
                                    message: ''
                                });
                            }, children: "Try Again" }), _jsx(Link, { className: "btn btn-secondary", to: "/user/profile", children: "View Profile" })] }), result.status === true &&
                _jsxs(_Fragment, { children: [_jsx(Alert, { type: "success", dismissible: false, message: result.message, onDismiss: function () { } }), _jsx(Link, { className: "btn btn-primary", to: "/user/profile", children: "View Profile" })] })] }));
};
export default UpdatePassword;
